// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"iframe-m__wrapper__1_I35"};